import { TRPCClientError } from '@trpc/client'
import { logger } from '@loc/helpers/src/logger/client'

import type { WebRouter } from '@loc/server'

import { globalErrorEmitter } from '@/components/GlobalErrorHandler/events'
import { unknownErrorMessage } from '@/components/GlobalErrorHandler/helpers'


import { getErrorMessage } from '@loc/helpers/src/errors/message';
export type AppTRPCClientError = TRPCClientError<WebRouter>

export function isAppTRPCClientError(err: unknown): err is AppTRPCClientError {
  return err instanceof TRPCClientError
}

export function onQueryClientError(err: unknown) {
  // 仅处理非 TRPCClientError，当前暂不清楚什么情况会抛出非 TRPCClientError，
  // TRPCClientError 统一通过 throwGlobalTrpcError 处理
  if (!isAppTRPCClientError(err)) {
    logger.debug('non-TRPCClientError', err)
    globalErrorEmitter.emit(
      'message',
      getErrorMessage(err) || unknownErrorMessage,
    )
  }
}

export function throwGlobalErrorMessage(msg: string) {
  globalErrorEmitter.emit('message', msg)
}

export function throwGlobalServerError(
  errorCode: number | string,
  errorMessage: string,
) {
  globalErrorEmitter.emit('server-error', errorCode, errorMessage)
}

export function throwGlobalTrpcError(
  error: AppTRPCClientError,
  ignore = false,
) {
  globalErrorEmitter.emit('trpc-error', error, ignore)
}
